'use client';
import { styled } from '@mui/material/styles';
import {
  gutterSmAndUp,
  gutterXs,
} from '@repo/ui/src/styles/variables';

export const TitledSplitToutContentContainer = styled('div')`
  .divider {
    &::after {
      content: '';
      height: 0.5rem;
      width: 5rem;
      display: block;
      margin-left: auto;
      margin-right: auto;
      background-color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  .dividerTop {
    &::after {
      margin-bottom: 1.5rem;
    }
  }

  .dividerBottom {
    &::after {
      margin-top: 1.5rem;
    }
  }

  .heading {
    padding-top: ${gutterXs};
    padding-bottom: ${gutterSmAndUp};
    ${(props) => props.theme.breakpoints.down('md')} {
      padding-bottom: ${gutterXs};
    }
  }

  .leftColumn {
    padding-right: 0.75rem;
    padding-bottom: ${gutterXs};
    ${(props) => props.theme.breakpoints.down('md')} {
      padding-right: 0;
    }
  }

  .rightColumn {
    padding-left: 0.75rem;
    padding-bottom: ${gutterXs};
    ${(props) => props.theme.breakpoints.down('md')} {
      padding-left: 0;
    }
  }
`;